var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:{'is-show': _vm.isDirection}},[_vm._m(0),_c('div',{ref:"menu",staticClass:"header__menu",on:{"click":function($event){return _vm.toggleSidebar()}}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"header__logo",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/img/logo.svg","alt":""}})])
}]

export { render, staticRenderFns }